import { cn } from './cn';

export interface SkeletonProps {
  /** Extra classes — use to set width, height, rounded, etc. */
  className?: string;
  /** Pill shape shorthand. */
  variant?: 'rect' | 'circle' | 'text';
  /** Number of lines when variant = 'text'. */
  lines?: number;
}

const shimmer =
  'relative overflow-hidden bg-line/60 dark:bg-surface-2 ' +
  'before:absolute before:inset-0 before:-translate-x-full ' +
  'before:bg-gradient-to-r before:from-transparent ' +
  'before:via-white/[0.12] dark:before:via-white/[0.06] ' +
  'before:to-transparent before:animate-shimmer';

export function Skeleton({ className, variant = 'rect', lines = 3 }: SkeletonProps) {
  if (variant === 'text') {
    return (
      <div className="flex flex-col gap-2">
        {Array.from({ length: lines }).map((_, i) => (
          <div
            key={i}
            className={cn(
              shimmer,
              'h-3 rounded-full',
              i === lines - 1 ? 'w-3/4' : 'w-full',
            )}
          />
        ))}
      </div>
    );
  }

  return (
    <div
      className={cn(
        shimmer,
        variant === 'circle' ? 'rounded-full' : 'rounded-xl',
        className,
      )}
    />
  );
}
